/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stealth_Access_SendingInputs */



/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Stealth_Access_SendingInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const stealth_access_sending = /** @type {((inputs?: Stealth_Access_SendingInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stealth_Access_SendingInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Sending")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Skickar")
	return /** @type {LocalizedString} */ ("Sender")
});